import { alpha } from '@mui/material/styles';

import {
  background,
  common,
  communicate,
  error,
  info,
  neutral,
  primary,
  receiving,
  sales,
  secondary,
  seenc,
  shipping,
  status,
  success,
  tertiary,
  text,
  warning,
} from './colors';

export function createSeencPalette() {
  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[900], 0.38),
      disabledBackground: alpha(neutral[900], 0.12),
      focus: alpha(neutral[900], 0.16),
      hover: alpha(neutral[900], 0.04),
      selected: alpha(neutral[900], 0.12),
    },
    communicate,
    divider: '#F2F4F7',
    error,
    info,
    mode: 'light',
    neutral,
    success,
    tertiary,
    warning,
    common,
    primary,
    secondary,
    background,
    text,
    seenc,
    sales,
    shipping,
    receiving,
    status,
  };
}
